// extracted by mini-css-extract-plugin
export var details = "_fl-0";
export var inspectorPopover = "_fl-1";